import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggleButton', 'expandArea', 'destroyField', 'destroyButton', 'disabledDestroyButton'];

  toggleHandler() {
    this.expandAreaTargets.forEach((target) => { target.classList.toggle('hidden'); });
    this.toggleButtonTarget.querySelector('div').classList.toggle('rotate-180');
  }

  destroy() {
    if (this.hasDestroyFieldTarget) {
      this.destroyFieldTarget.disabled = false;
      this.element.classList.add('hidden');
      this.dispatch('destroy');
    } else {
      this.element.remove();
    }
  }

  destroyEventHandler() {
    const sameControllers = this.application.controllers.filter(
      (controller) => controller.identifier === this.identifier,
    );

    const visibleControllers = sameControllers.filter(
      (controller) => this.constructor.isVisible(controller.element),
    );

    if (visibleControllers.length <= 1) {
      this.destroyButtonTarget.classList.add('hidden');
      this.disabledDestroyButtonTarget.classList.remove('hidden');
    }
  }

  static isVisible(element) {
    return element.offsetParent !== null && getComputedStyle(element).visibility !== 'hidden';
  }
}
